import { Text } from "pixi.js";
import { Row } from './row/Row'
import { graphic } from "../Graphic";

export class EntityLabel {

    static DISPLAY = {
        LEFT: 'left',
        RIGHT: 'right',
        HIDDEN: 'hidden'
    };

    constructor(entity, value, display) {
        this.entity = entity;
        this.display = display;
        this.setValue(value);
    }

    setValue(value) {
        if (this.value === value) return;

        this.value = value;

        if (this.entity instanceof Row && this.entity.id) {
            graphic.rowsLabel[this.entity.id] = value;
            graphic.handleDuplicatedSeats();
        }

        if (!this.label) {
            this.label = new Text(value, Row.labelStyle);
        } else {
            this.label.text = value;
        }

        this.update();
    }

    setDisplay(value) {
        this.display = value;
        this.update();
    }

    update() {
        switch (this.display) {
            case EntityLabel.DISPLAY.RIGHT: {
                const calc = val => val / graphic.zoom;
                const rightGraphicItem = this.entity.graphicItems[this.entity.graphicItems.length - 1];
                this.label.x = ((calc(rightGraphicItem.getBounds().width) + (Row.margin * 2)) * (this.entity.graphicItems.length - 1) + 10) - (Row.margin * 2);
                this.label.x = calc(this.entity.seatsContainer.getBounds().width);
                this.label.y = - (this.label.height / 2) + rightGraphicItem.y;
                this.label.visible = true;
                break;
            }
            case EntityLabel.DISPLAY.HIDDEN: {
                this.label.visible = false;
                break;
            }
            case EntityLabel.DISPLAY.LEFT:
            default: {
                this.label.x = -this.label.width - 10;
                this.label.y = this.entity.graphicItems[0].height / 2 - (this.label.height / 2);

                if (this.entity instanceof Row) {
                    this.label.y = - (this.label.height / 2) + this.entity.graphicItems[0].y;
                    this.label.x -= 10;
                }
                this.label.visible = true;

                break
            }
        }
        this.label.dirty++;
        this.label.clearDirty++;
    }

    draw() {
        this.entity.container.addChild(this.label);
        this.update();
    }

    destroy() {
        this.entity.container.removeChild(this.label);
    }
}